import { useCallback, useEffect, useState } from 'react';

import { setClipboard } from '@libs/clipboard';

export function useClipboard() {
  const [state, setState] = useState<'idle' | 'copying' | 'copied' | 'error'>('idle');
  const onCopy = useCallback((val: string) => {
    setState('copying');
    try {
      setClipboard(val);
      setState('copied');
    } catch {
      setState('error');
    }
  }, []);

  useEffect(() => {
    if (state === 'idle' || state === 'copying') return;
    const to = setTimeout(() => {
      setState('idle');
    }, 5 * 1000);

    return () => clearTimeout(to);
  }, [state]);

  return {
    copy: onCopy,
    copyState: state,
  };
}
